import { createBrowserRouter, Navigate } from 'react-router-dom';
import { MainLayout } from '@/shared/components/MainLayout';
import { DemoLayout } from '@/shared/components/DemoLayout';
import { DashboardPage } from '@/features/dashboard/pages/DashboardPage';
import { GuidesPage } from '@/features/guides/pages/GuidesPage';
import { GuideDetailPage } from '@/features/guides/pages/GuideDetailPage';
import { CreateGuidePage } from '@/features/guides/pages/CreateGuidePage';
import { SearchHistoryPage } from '@/features/guides/pages/SearchHistoryPage';
import { SearchClustersPage } from '@/features/guides/pages/SearchClustersPage';
import { SettingsPage } from '@/features/settings/pages/SettingsPage';
import { LoginPage } from '@/shared/components/LoginPage';
import { ProtectedRoute } from '@/shared/components/ProtectedRoute';
import { SearchProvider } from '@/features/dashboard/context/SearchContext';

const isDemo = import.meta.env.VITE_APP_MODE === 'demo';

const demoRoutes = [
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <SearchProvider>
          <DemoLayout />
        </SearchProvider>
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <DashboardPage />,
      },
    ],
  },
  {
    path: '/demo',
    element: <Navigate to="/" replace />,
  },
  {
    path: '/guides',
    element: <Navigate to="/" replace />,
  },
  {
    path: '/settings',
    element: <Navigate to="/" replace />,
  },
];

const adminRoutes = [
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/guides',
    element: (
      <ProtectedRoute>
        <MainLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <GuidesPage />,
      },
      {
        path: 'new',
        element: <CreateGuidePage />,
      },
      {
        path: ':id',
        element: <GuideDetailPage />,
      },
    ],
  },
  {
    path: '/usage',
    element: (
      <ProtectedRoute>
        <MainLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <SearchHistoryPage />,
      },
    ],
  },
  {
    path: '/clusters',
    element: (
      <ProtectedRoute>
        <MainLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <SearchClustersPage />,
      },
    ],
  },
  {
    path: '/demo',
    element: (
      <ProtectedRoute>
        <MainLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <DashboardPage />,
      },
    ],
  },
  {
    path: '/settings',
    element: (
      <ProtectedRoute>
        <MainLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <SettingsPage />,
      },
    ],
  },
  {
    path: '/dashboard',
    element: <Navigate to="/demo" replace />,
  },
  {
    path: '/',
    element: <Navigate to="/demo" replace />,
  },
];

export const router = createBrowserRouter(isDemo ? demoRoutes : adminRoutes);